import {ChangeDetectionStrategy, Component} from '@angular/core';
import {ToolbarItemUploadDocument} from './toolbar-item-upload-document.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-toolbar-item-upload-attachment-type',
  templateUrl: './toolbar-item-upload-attachment-type.component.html',
  styles: [`
    ::ng-deep .ui-button-text {
      padding-left: 20px !important;
    }
  `]
})
export class ToolbarItemUploadAttachmentTypeComponent extends ToolbarItemUploadDocument {

}
